var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubirConfirmarPrenomina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}.cls-2{fill:#d2dde6;}.cls-3{fill:#f3d585;}.cls-4{fill:#5d646f;}.cls-5{fill:#cd686a;}.cls-6{fill:#ecbb4c;}.cls-7{fill:#e8f8dd;}.cls-8{fill:#88ac6d;}.cls-9{fill:#b4d19f;}.cls-10{fill:#df8a93;}.cls-11{fill:#f7ef66;}.cls-12{fill:#f3f3e5;}.cls-13{fill:#7ac943;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "subir_confirmar_prenomina") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.5,
    cy: 72.5,
    r: 72.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.48,46.21h14v8h-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.48,32.21h8v6a4,4,0,0,1-8,0v-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.48,26.21a6,6,0,0,1,6,6h-12A6,6,0,0,1,54.48,26.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.48,37.21h2v2h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.49,68.2h8v6a4,4,0,1,1-8,0v-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.49,62.2a6,6,0,0,1,6,6h-12A6,6,0,0,1,33.49,62.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.49,73.2h2v2h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M53.48,46.21h2v5h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.49,78.2h8v6h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.48,68.2h8v6a4,4,0,0,1-8,0v-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.48,62.2a6,6,0,0,1,6,6h-12A6,6,0,0,1,54.48,62.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.48,73.2h2v2h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.48,78.2h8v6h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.47,68.2h8v6a4,4,0,1,1-8,0v-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.47,62.2a6,6,0,0,1,6,6h-12A6,6,0,0,1,75.47,62.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.47,73.2h2v2h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.47,78.2h8v6h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M34.49,55.2h-2v-10h8v2h-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.47,55.2h-2v-8h-6v-2h8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.48,57.2h2v2h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M74.47,57.2h2v2h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.49,57.2h2v2h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M42.48,45.21h2v2h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64.48,45.21h2v2h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M70.52,118.79h47V66.57l-8.35-8.35H70.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M110.2,72.84H91.4V93.73h23V72.84Zm2.09,2.09V77H110.2V74.93Zm-4.18,0V77H106V74.93Zm-4.17,0V77h-2.09V74.93Zm-4.18,0V77H97.67V74.93Zm-6.27,0h2.09V77H93.49Zm0,16.71V79.11h2.09V91.64Zm4.18,0V79.11h2.09V91.64Zm4.18,0V79.11h2.09V91.64Zm4.17,0V79.11h2.09V91.64Zm6.27,0H110.2V79.11h2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M109.16,66.57h8.35l-8.35-8.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M59,72.84H86.18a2.09,2.09,0,0,1,2.09,2.09V116.7a2.09,2.09,0,0,1-2.09,2.09H59a2.1,2.1,0,0,1-2.09-2.09V74.93A2.1,2.1,0,0,1,59,72.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M70.52,93.73H74.7V97.9H70.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M62.17,93.73h4.17V97.9H62.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M78.87,93.73h4.18V97.9H78.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M70.52,102.08H74.7v4.18H70.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M62.17,102.08h4.17v4.18H62.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M78.87,102.08h4.18v4.18H78.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M70.52,110.43H74.7v4.18H70.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M62.17,110.43h4.17v4.18H62.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M78.87,110.43h4.18v4.18H78.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.12,77h23V89.55h-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M77.09,85.68l3.13-3.14L81.7,84l-3.13,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M71.87,85.68,75,82.54,76.48,84l-3.13,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M107.07,113.57h10.44v2.08H107.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M102.89,113.57H105v2.08h-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.7,62.4h2.09v2.09H74.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M78.87,62.4H94.54v2.09H78.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.7,66.57H91.4v2.09H74.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M114.38,100V97.9H110.2V95.81h-2.09V97.9H105a1,1,0,0,0-1,1v4.17a1,1,0,0,0,1,1h3.13v2.09h-4.17v2.08h4.17v2.09h2.09v-2.09h3.13a1,1,0,0,0,1-1v-4.18a1,1,0,0,0-1-1H110.2V100Zm-2.09,4.18v2.09H110.2v-2.09Zm-4.18-2.09H106V100h2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.4,97.9h8.36V100H91.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.4,102.08h2.09v2.09H91.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.58,102.08h4.18v2.09H95.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.4,106.26h10.45v2.08H91.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "113.7 47.27 100.86 34.65 88.24 47.49 97.3 47.41 97.3 67.01 104.64 67.01 104.64 47.35 113.7 47.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "114.7 45.8 101.87 33.18 89.24 46.02 98.31 45.94 98.31 65.54 105.64 65.54 105.64 45.88 114.7 45.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubirConfirmarPrenomina);
export default __webpack_public_path__ + "static/media/subir_confirmar_prenomina.bb5d2ea32958d6040d7ed14cc84eb334.svg";
export { ForwardRef as ReactComponent };